var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "errPage-container" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("h1", { staticClass: "text-jumbo text-ginormous" }, [
              _vm._v(" Oops! ")
            ]),
            _c("h2", [_vm._v("你没有权限去该页面= = session 无效")]),
            false
              ? _c("ul", { staticClass: "list-unstyled" }, [
                  _c("li", [_vm._v("或者你可以去:")]),
                  _c(
                    "li",
                    { staticClass: "link-type" },
                    [
                      _c("router-link", { attrs: { to: "/dashboard" } }, [
                        _vm._v(" 回首页 ")
                      ])
                    ],
                    1
                  ),
                  _c("li", { staticClass: "link-type" }, [
                    _c("a", { attrs: { href: "https://www.taobao.com/" } }, [
                      _vm._v("随便看看")
                    ])
                  ]),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.dialogVisible = true
                          }
                        }
                      },
                      [_vm._v("点我看图")]
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("img", {
              attrs: {
                src: _vm.errGif,
                width: "313",
                height: "428",
                alt: "Girl has dropped her ice cream."
              }
            })
          ])
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, title: "随便看" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [_c("img", { staticClass: "pan-img", attrs: { src: _vm.ewizardClap } })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }